<template>
  <EditablePanel
      class="AddressPanel"
      :title="title"
      :editable="editable"
      :emptyAddress="emptyAddress"
      :loading=loading
      :isLoading="isLoading"
      @edit="toggleEditing"
      @save="saveChanges"
  >
    <div class="fields font-size-middle" v-if="loading===false">
      <HybridInput
          :editable="editable" class="field name" v-model="address.name" placeholder="imię"/>
      <HybridInput
          :editable="editable" class="field surname" v-model="address.surname" placeholder="nazwisko"/>
      <HybridInput
          :editable="editable" class="field street" v-model="address.street" placeholder="ulica"/>
      <HybridInput
          :editable="editable" class="field post" v-model="address.postCode" placeholder="kod pocztowy"
          :distinctive="true"
          :validator="'postCode'" 
          :invalid="invalidAddress.postCode"
          :pattern="'\\d{2}-\\d{3}'"
          :title="'Prawidłowy format to XX-XXX'"/>
      <HybridInput
          :editable="editable" class="field city" v-model="address.city" placeholder="miasto"/>
      <HybridInput
          :editable="editable" class="field phone" v-model="address.phoneNumber" placeholder="numer telefonu"
          :distinctive="true"
          :validator="'phone'" 
          :invalid="invalidAddress.phoneNumber" 
          :pattern="'\\d{9}'" 
          :title="'Podaj 9 liczb'"/>
    </div>
    <div class="ph-item" v-else>
        <div class="ph-col-12">
            <div class="ph-row">
                <div class="big"></div>
                <div class="big"></div>
                <div class="big"></div>
                <div class="big"></div>
            </div>
        </div>
    </div>
  </EditablePanel>
</template>

<script>
import EditablePanel from './EditablePanel.vue'
import HybridInput from './HybridInput.vue'

export default {
  name: 'AddressPanel',
  components: {
    EditablePanel,
    HybridInput,
  },
  props: {
    editable: {
      type: Boolean,
      required: false,
    },
    address: {
      default: function() {
        return {
          name: '',
          surname: '',
          street: '',
          postCode: '',
          city: '',
          phoneNumber: ''
        }
      },
      required: false,
    },
    title: {
      default: '',
      required: false,
    },
    emptyAddress: {
      type: Boolean,
      default: false,
      required: false,
    },
    loading:{
      type: Boolean,
      default: false,
      required: false,
    },
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      invalidAddress: {
        postCode: false,
        phoneNumber: false
      }
    }
  },
  methods: {
    toggleEditing () {
      this.$emit('edit')
    },
    saveChanges () {
      if (this.$props.address.postCode.length !== 6) {
        this.invalidAddress.postCode = true
      } else {
        this.invalidAddress.postCode = false
      }
      
      if (this.$props.address.phoneNumber.length !== 9) {
        this.invalidAddress.phoneNumber = true
      } else {
        this.invalidAddress.phoneNumber = false
      }

      if (Object.keys(this.invalidAddress).every((k) => !this.invalidAddress[k])) {
        this.$emit('save')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/globals.scss";

.AddressPanel {
  .fields {
    display: grid;
    grid-template-areas: 'name surname'
                'street street'
                'post post'
                'city city'
                'phone phone';
    grid-template-columns: 1fr 1fr;
    grid-gap: 0 50px;

    .name {
      grid-area: name;
    }

    .surname {
      grid-area: surname;
    }

    .street {
      grid-area: street;
    }

    .post {
      grid-area: post;
    }

    .city {
      grid-area: city;
    }

    .phone {
      grid-area: phone;
    }

    .field {
      margin-bottom: 0;
    }
  }
}

.ph-item{
    direction: ltr;
    position: relative;
    width: 355px;
    padding: 0;
    overflow: hidden;
    margin-bottom: 0;
    background-color: transparent;
    border: none;
    border-radius: none;

    &::before{
      display: none;
    }

    .ph-row{
      display: block;
      margin: 0;
    }

    .ph-col-12{
      margin-top: 25px;
      padding: 0;
    }

    .big{
      height: 22px;
      width: 100%;
      border-radius: 6px;
      position: relative;
      background-color: #727271;

      &:last-child{
          margin: 0;
      }

      &::before{
        content: " ";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 50%;
        width: 500%;
        margin-left: -250%;
        -webkit-animation: phAnimation 0.8s linear infinite;
        animation: phAnimation 0.8s linear infinite;
        background: linear-gradient(
            to right,
          rgba(255, 255, 255, 0) 46%,
          rgba(255, 255, 255, 0.35) 50%,
          rgba(255, 255, 255, 0) 54%) 50% 50%;
        z-index: 0;
      }
    }

    .ph-item > * {
      padding: 0;
    }

}

@media only screen and (max-width: $phone-max-width) {
  .ph-item {
    width: 100%;
  }
}

@media only screen and (max-width: 400px) {
  .ph-item {
    width: 70vw;
  }
}

</style>
